import HoldingsDocumentsModal from "./holdings-documents-modal";

export default HoldingsDocumentsModal;
